import {useEffect} from "react";

export default function useBackdropFilterToggle(toggle: boolean) {
  useEffect(() => {
    document.body.classList.toggle('no-filter', toggle);
  }, [toggle]);
}
